import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Heading, { type HeadingProps } from "@client/controls/HTML/Heading/component";
import { useI18n } from "@common/hooks/i18n";
import { formatMoneyDisplay, formatRepeatWithType } from "@common/lib/format";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ModuleButton } from "../../Button";
import { type SlidersValue } from "../Content";
import { type PackagePricing } from "../types";
import Item from "./Item/container";
import { getFees, getMonthPrice } from "./lib";

export type MapProps = RootContainerProps & {
  childrenIds: string[];
  frequency: PackagePricing.BillingFrequencyKey;
  package: PackagePricing.Api.Package;
  price: number;
  priceMode: "month" | "period";
  priceHeadingProps: HeadingProps;
  sliders: SlidersValue;
  style: React.CSSProperties;
  tiers: PackagePricing.Api.Tiers;
  titleHeadingProps: HeadingProps;
  trialPagePath: string;
};
export default (props: MapProps) => {
  const i18n = useI18n();
  const periodLabel = React.useMemo(() => {
    switch (props.frequency) {
      case "Month":
        return "Monthly";
      case "Quarter":
        return "Every 3 months";
      case "Year":
        return "Yearly";
    }
  }, [props.frequency]);

  const finalPrice = React.useMemo(() => {
    return props.price + getFees(props.package, props.tiers, props.frequency, props.sliders);
  }, [props.package, props.price, props.sliders, props.tiers]);

  const navigate = useNavigate();

  return (
    <div className="block" style={props.style}>
      <div className="price">
        <Heading {...props.titleHeadingProps} content={periodLabel} />
        <Heading
          {...props.priceHeadingProps}
          content={
            props.priceMode === "month"
              ? formatRepeatWithType(
                  i18n,
                  formatMoneyDisplay(getMonthPrice(finalPrice, props.frequency), "USD", { digits: 0 }),
                  1,
                  "Month"
                )
              : formatMoneyDisplay(finalPrice, "USD", { digits: 0 })
          }
        />
        {/* hide to keep the height */}
        <p className="info" style={{ visibility: props.frequency === "Month" ? "hidden" : undefined }}>
          {props.priceMode === "month"
            ? formatRepeatWithType(i18n, formatMoneyDisplay(finalPrice, "USD", { digits: 0 }), 1, props.frequency, {
                quarter: "3Months"
              })
            : formatRepeatWithType(
                i18n,
                formatMoneyDisplay(getMonthPrice(finalPrice, props.frequency), "USD", { digits: 0 }),
                1,
                "Month"
              )}
        </p>
      </div>

      <div className="separator" style={{ borderTop: `1px solid ${props.style.borderColor}` }}></div>

      <div className="wsc_content_lists emt-custom-icon list-icon-colored">
        <div
          className="items_container"
          style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", rowGap: "10px" }}
        >
          {props.childrenIds.map((x) => (
            <Item key={x} id={x} source={props.source} />
          ))}
        </div>
      </div>

      <ModuleButton {...getRootContainerProps(props)} onClick={() => navigate(props.trialPagePath)} />
    </div>
  );
};
